import { RefreshCw, X } from "lucide-react";
import { Button } from "./ui/button";
import { usePwaUpdate } from "../hooks/usePwaUpdate";

/** Floating banner — installed PWA only; dismiss hides until user opens Notifications. */
export default function AppUpdateBanner() {
  const { showBanner, applyUpdate, dismissBanner } = usePwaUpdate();

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-20 left-4 right-4 z-[9998] mx-auto max-w-lg sm:left-auto sm:right-5 sm:max-w-md pointer-events-none"
      role="status"
      aria-live="polite"
    >
      <div className="pointer-events-auto rounded-2xl border border-accent/30 bg-card shadow-elevated p-4">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-accent/15 text-accent">
            <RefreshCw className="h-4 w-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-foreground">App update available</p>
            <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
              Tap update to refresh your installed app. You can also update later from Notifications.
            </p>
            <div className="mt-3 flex flex-col sm:flex-row flex-wrap gap-2">
              <Button size="sm" className="w-full sm:w-auto" onClick={applyUpdate}>
                Update now
              </Button>
              <Button size="sm" variant="outline" className="w-full sm:w-auto" onClick={dismissBanner}>
                Later
              </Button>
            </div>
          </div>
          <button
            type="button"
            onClick={dismissBanner}
            className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full hover:bg-accent/10 text-muted-foreground"
            aria-label="Dismiss update notice"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
